<template>
    <div class="TTL-image-video">
        <el-form :inline="true">
            <el-form-item>
                <a class="TTL-fresh" @click="freshInit"></a>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                v-model="param.time"
                type="datetimerange"
                size="large"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="YYYY-MM-DD HH:mm:ss"
                @change="param.ischange=true"
                />
            </el-form-item>
            <el-form-item>
                <div class="TTL-input">
                <el-input v-model="param.key" placeholder="关键字" round size="large" prefix-icon="Search" clearable @change="param.ischange=true"/>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="warning" size="large" round @click="gettemplist">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="warning" size="large" round @click="addImageOrVideo">上传</el-button>
            </el-form-item>
        </el-form>

        <div class="TTL-image-video-main-empty" v-if="list.length==0" >
        <el-empty description="没有任何记录" />
        </div>
        <div class="TTL-image-video-main" v-loading="param.loading" v-if="list.length > 0">
            <div class="TTL-image-video-main-info" v-for="(item,index) in list">
            <a class="TTL-image-video-label" @click="playvideo(item)" v-if="item.type==2"></a>
            <div class="TTL-image-video-content">
                <span>{{item.time}}，{{item.content}}</span>
            </div>
            <el-image
                width="300"
                height="240"
                :src="item.url"
                :zoom-rate="1.2"
                :preview-src-list="[item.url]"
                :initial-index="10"
                :z-index="15"
                fit="cover"
            />
            </div>
        </div>
        <div class="block TTL-page-block" v-if="list.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="param.p"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="param.rollpage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="param.row"
            />
        </div>

        <div class="TTL-dialog">
        <el-dialog v-model="upload.dialog" title="上传文件" width="45%" :before-close="closeBefore">
            <el-form :model="form" v-loading="upload.loading">
            <el-form-item label="上传时间" label-width="80">
                <el-date-picker
                    v-model="upload.time"
                    type="date"
                    size="large"
                    placeholder="上传时间"
                    value-format="YYYY-MM-DD"
                />
            </el-form-item>
            <el-form-item label="备注描述" label-width="80">
                <el-input v-model="upload.content" placeholder="请填写备注描述" round size="large" prefix-icon="Mug" clearable/>
            </el-form-item>
            <el-form-item>
                <div :class="upload.uploads.length > 0 ? 'TTL-imagelists' : 'TTL-imagelists backicon'" @click="handleuploadfiles">
                    <div class="TTL-imagelists-info" v-for="(item,index) in upload.uploads" :key="index">
                    <el-image 
                    :src="item.url!='' ? item.url : require('@/assets/icon/defaulimg.jpg')" 
                    :width="150"
                    :height="120"
                    :preview-src-list="[]" 
                    :initial-index="1"
                    preview-teleported="true"
                    :zoom-rate="1.2" 
                    fit="cover"  
                    />
                    <a class="TTL-imagelists-close" @click.stop.prevent="closeimage(index)" v-if="item.type==2"></a>
                    <span :class="item.url!='' ? 'TTL-imagelists-percent TTL-imagelists-percent-finish' : 'TTL-imagelists-percent'">{{item.url!='' ? '100%' : '0%'}}</span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="TTL-footer">
                    <el-button type="warning" size="large" round @click="savefiles">保存</el-button>
                    <el-button size="large" round @click="closeBefore">取消</el-button>
                </div>
            </el-form-item>
            </el-form>
        </el-dialog>
        </div>

        <!-- 播放视频 -->
        <div class="TTL-dialog">
            <el-dialog v-model="playparam.view" title="播放视频" :before-close="closeplay" width="60%">
            <vue3VideoPlay v-bind="playparam.options" :poster='playparam.thumb' ref="videoPlayer"/>
            </el-dialog>
        </div>

        <!-- 自定义组件 -->
        <div><input type="file" id="ImageVideoFile" style="display:none;" multiple @change="getMyfiles" /></div>

    </div>
</template>

<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
export default {
    props: ['value'],
    components:{

    },  
    data() {
        return {
            param: {
                time:[],
                key:'',
                ischange:false,
                loading:false,
                p:1,
                rollpage:30,
                row:0
            },

            list:[],


            upload: {
                dialog:false,
                loading:false,
                time:'',
                content:'',
                uploads:[],
            },


            uploadparam: {
                type:'library',
                imagetype:'library',
            },

            playparam: {
                view:false,
                thumb:'',
                options:{
                    width: '100%', //播放器高度
                    height: '550px', //播放器高度
                    color: "#409eff", //主题色
                    title: '', //视频名称
                    src: "http://api.home.com/Upload/video/Library/20231020/708d320e14c85e4e39c92fee440ddfef.mp4", //视频源
                    muted: false, //静音
                    webFullScreen: false,
                    speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
                    autoPlay: false, //自动播放
                    loop: true, //循环播放
                    mirror: false, //镜像画面
                    ligthOff: false,  //关灯模式
                    volume: 0.3, //默认音量大小
                    control: true, //是否显示控制器
                }
            },


        }
    },

    watch: {
        value(val) {
            if(val) { 
                this.resetparam(); //重置参数
                this.gettemplist(); //获取列表信息
            }
        }
    },

    mounted() {
        
    },

    methods: {

        /** 初始化加载 **/
        freshInit() {
            var load=this.$loading.service(this.$loadingparam); //加载loading动画
            this.gettemplist(); //刷新列表数据
            load.close(); //关闭loading动画
        },


        /** 播放视频 **/
        playvideo(item) {
            this.playparam.view=true;
            this.playparam.thumb=item.url;
            this.playparam.options.src=item.videourl;

            let _this=this;
            setTimeout(function() {
                _this.$refs.videoPlayer.play(); //播放
            },200);
        },

        /** 关闭窗口 **/
        closeplay() {
            this.$refs.videoPlayer.pause(); //暂停播放
            this.playparam.view=false;
        },


        /** 获取列表数据信息 **/
        gettemplist() {
            this.param.loading=true;
            if(this.param.ischange) {
                this.param.p=1;
                this.param.rollpage=30;
            }

            this.list=[];
            INTERFACE_MODEL_GENEALOGY.GET_MEMBER_LIBRARY_LIST(this.param).then((res) => {
                this.param.loading=false;
                if(res.status > 0) return false;

                this.param.row=res.data.count;
                this.list=res.data.list;
                console.log(this.list);
            })
        },


        /** 调整每页条数 **/
        handleSizeChange(e) {
            this.param.rollpage=e;
            this.gettemplist();
        },


        /** 调整页数 **/
        handleCurrentChange(e) {
            this.param.p=e;
            this.gettemplist();
        },


        /** 重置信息 **/
        resetparam() {
            this.param.time=[];
            this.param.key='';
            this.param.ischange=false;
            this.param.loading=false;
            this.param.p=1;
            this.param.rollpage=30;
            this.param.row=0;
        },

        

        /** 上传图片/视频 **/
        addImageOrVideo() {
            this.upload.dialog=true;
            this.upload.time='';
            this.upload.content='';
            this.upload.uploads=[];
        },
        

        /** 保存文件数据 **/
        savefiles() {
            this.upload.loading=true;
            this.upload.uploadlists=[];
            for(var i=0;i < this.upload.uploads.length; i++) this.upload.uploadlists.push(this.upload.uploads[i]);
            this.upload.uploadlists=JSON.stringify(this.upload.uploadlists);
            INTERFACE_MODEL_GENEALOGY.SAVE_MEMBER_LIBRARY_FILE(this.upload).then((res) => {
                this.upload.loading=false;
                if(res.status > 0) return false;
                this.upload.dialog=false;

                this.gettemplist(); //刷新列表信息
            })
        },


        /** 关闭上传窗口 **/
        closeBefore() {
            this.$confirm.confirm(
                '关闭窗口会停止当前操作，是否要停止？',
                '删除提示',
                {confirmButtonText:'停止',cancelButtonText:'取消',type: 'warning'}
            )
            .then(()=> {
                this.upload.dialog=false;
            })
            .catch(()=> {
                
            });
        },


        /** 删除图片 **/
        closeimage(index) {
            this.upload.uploads.splice(index,1);
        },


        /** 上传文件信息 **/
        handleuploadfiles() {
            document.getElementById('ImageVideoFile').click();
        },


        /** 获取问诊图片 **/
        getMyfiles(e) {
            let _this=this;  

            //加载图片信息
            for(var i=0; i < e.srcElement.files.length; i++) this.upload.uploads.push({url:'',type:1});
            //延迟上传图片信息
            setTimeout(function() {
                for(var i=0; i < e.srcElement.files.length; i++) {
                    //上传图片到接口操作
                    INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:_this.uploadparam.imagetype,File:e.srcElement.files[i]}).then((res) => {
                        if(res.status > 0) return false;
                        let url=_this.$ImageAddress+res.data.url;
                        let videourl=_this.$ImageAddress+res.data.videourl;

                        //检查列表中未上传的图片文件信息
                        for(var ii=0; ii < _this.upload.uploads.length; ii++) {
                            if(_this.upload.uploads[ii].url=='') {
                                _this.upload.uploads[ii].url=url;
                                _this.upload.uploads[ii].videourl=videourl;
                                _this.upload.uploads[ii].type=res.data.type;
                                break;
                            }
                        }
                        
                        if(i+1==e.srcElement.files.length) e.srcElement.value=''; //最后一个文件完成后，清空数据
                    });
                }
            },500);
        },


    },

}
</script>
<style lang="scss" Scoped>
.TTL-switch {width:100%;text-align:right;}
.TTL-image-video {margin-top:30px;}
.TTL-image-video-main {width:100%;margin-top:20px;display:inline-block;}
.TTL-image-video-main-empty {width:100%;margin-top:20px;display:inline-block;}
.TTL-image-video-main-empty .el-empty__description p {letter-spacing:5px;}
.TTL-image-video-main-info {cursor:pointer;float:left;width:240px;height:160px;border-radius:15px;margin:0 45px 45px 0;background-color:#E4E7ED;transition:.5s all;position:relative;overflow:hidden;}
.TTL-image-video-main-info:hover {box-shadow:5px 5px 10px #909399;}
.TTL-image-video-label {width:55px;height:55px;background:url(@/assets/icon/video.png);background-size:55px;position:absolute;top:0;left:0;z-index:10;margin-left:92.5px;margin-top:52.5px;}
.TTL-image-video-main-info .el-image {border-radius:15px;}
.TTL-image-video-main-info .el-image img {width:240px;}
.TTL-image-video-content {position:absolute;bottom:0;left:0;width:calc(100% - 40px);height:30px;padding:0 20px;z-index:10;display:inline-block;}
.TTL-image-video-content span {font-size:13px;line-height:23px;color:#fff;width:100% !important;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;display:inline-block;}
.TTL-imagelists {background-color:#CDD0D6;width:calc(100% - 40px - 2px);display:inline-block;min-height:100px;padding:20px;border-radius:15px;border:1px solid #E6E8EB;cursor:pointer;}
.backicon {background:#CDD0D6 url(@/assets/icon/upload.png) no-repeat;background-size:70px;background-position:center;}
.TTL-imagelists-info {float:left;width:120px;height:90px;border-radius:15px;border:1px solid #E6E8EB;margin:0 20px 20px 0;position:relative;}
.TTL-imagelists-info .el-image {border-radius:15px;width:120px;height:90px;}
.TTL-imagelists-close {width:25px;height:25px;border-radius:50%;background:#F56C6C url(@/assets/icon/close.png) no-repeat;background-size:8px;background-position:center;position:absolute;top:0;right:0;margin:-10px -10px 0 0;}
.TTL-footer {margin-top:30px;}
.TTL-imagelists-percent {position:absolute;bottom:0;left:0;padding:0 10px;width:calc(100% - 20px);height:20px;border-radius:15px;text-align:right;font-size:12px;color:#606266;display:flex;justify-content:right;align-items:center;background:rgb(225,225,225,.7);font-weight:550;}
.TTL-imagelists-percent-finish {background:#E6A23C;color:#fff;}
</style>